import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const KIND_LABEL = { panel: "Painel", proxy: "Proxy", whatsapp: "WhatsApp", other: "Outro" };
export const fmtDay = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().slice(0, 2).join("/") : "—");
export const fmtAt = (iso) => (iso ? new Date(iso).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "");

export const useServices = (ms = 60000) => {
  const [d, setD] = useState({ items: [], alerts: 0 });
  const load = useCallback(() => api.get("/services").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(load, ms);
    window.addEventListener("services-changed", load);
    return () => { clearInterval(t); window.removeEventListener("services-changed", load); };
  }, [load, ms]);
  return { ...d, reload: load };
};

export const servicesChanged = () => window.dispatchEvent(new Event("services-changed"));
